module.exports = __webpack_public_path__ + "img/Readdit_Demo.11493082.gif";